export default __webpack_public_path__ + "static/O0197-78cb2b162113150d33e5be2bcf991e76.png";